import { render, staticRenderFns } from "./files-lecture.vue?vue&type=template&id=3cf273d8&"
import script from "./files-lecture.vue?vue&type=script&lang=js&"
export * from "./files-lecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports